import { Permissao } from "@app/models/util/permissao";
import { UnidadeAcesso } from "@app/models/util/unidade-acesso";

export class Funcionario {

  Id: number;
  Descricao: string;
  Email: string;
  Login: string;
  Senha: string;
  NomeFantasia: string;
  Autenticacao2Fatores: boolean;
  Funcionario: boolean;
  Advogado: boolean;
  Estagiario: boolean;
  AssistenteJuridico: boolean;
  AdvogadoParceiro: boolean;
  Parceiro: boolean;
  Oab: string;
  CNPJ_CPF: string;
  DataNascimento: Date;
  IE_RG: string;
  RGDataExpedicao: string;
  RGOrgaoExpedidor: string;
  EstadoCivil: string;
  Sexo: string;
  Endereco: string;
  EnderecoComplemento: string;
  Bairro: string;
  CidadeId: number;
  Estado: string;
  CEP: string;
  Telefone: string;
  Celular: string;
  EmpresaVinculado: string;
  AssinaturaEmail: string;
  Observacao: string;
  DataCriacao: Date;
  EnderecoNumero: string;
  UsuarioTipoId: number;
  UsuarioTipoDescricao: string;
  UnidadeId: number;
  UnidadeDescricao: string;
  Permissoes: Permissao[];
  UnidadesAcesso: UnidadeAcesso[];
  Ativo: boolean;
  Apelido: string;
  PaisCelular: string;
}
